import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

// Utils
import { fontSize } from "Utils/fontSize.js"

// Styles
import {
  SearchIconContainer,
  ActiveIconContainer,
  InputContainer,
  ErrorMessage,
  ActiveItem,
  Container,
  Input,
  Title,
} from "Components/Generic/GenericInput/index.style"

const GenericInput = ({
  placeholder,
  onClick,
  onActive,
  onChange,
  onBlur,
  value,
  name,
  onClickIcon,
  inputFontSize,
  activationDefaultProps,
  containerStyle,
  inputContainerStyle,
  activationPropsName,
  primaryActionColor,
  colorTitle,
  withActivation,
  inputStyle,
  title,
  showIcon,
  icon,
  unvalidValue,
  errorMessage,
  withMinWidth,
  type,
  min,
  max,
  step,
  disabled,
  role,
  fontSizeTitle,
  className,
  accept,
  heightTitle,
  searchIconContainerStyle,
  tooltip,
  isLoading,
  maxLength,
  isHiddenFleche,
  isDisableScroll,
}) => {
  const [inputValue, setInputValue] = useState(value)

  useEffect(() => {
    if (inputValue !== value) setInputValue(value)
  }, [value])

  var propsIfNumber = {}
  if (type === "number") {
    if (min !== undefined) propsIfNumber.min = min
    if (max !== undefined) propsIfNumber.max = max
    if (step !== undefined) propsIfNumber.step = step
  }

  const transformedValue = (type, value) => {
    return type === "number" ? `${value}` : value
  }

  const handleScroll = e => {
    // Prevent the input value change
    e.target.blur()
    // Prevent the page/container scrolling
    e.stopPropagation()
  }

  return (
    <>
      <Container style={containerStyle} className={className} onClick={onClick}>
        {title !== "" && (
          <Title
            fontSizeTitle={fontSizeTitle}
            colorTitle={colorTitle}
            heightTitle={heightTitle}
            isLoading={isLoading}
          >
            <p className={isLoading ? "loaderButton" : ""}>{title}</p>
          </Title>
        )}
        <InputContainer
          unvalidValue={unvalidValue}
          style={inputContainerStyle}
          withMinWidth={withMinWidth}
          isHiddenFleche={isHiddenFleche}
        >
          {withActivation && (
            <ActiveIconContainer primaryActionColor={primaryActionColor} onClick={onActive}>
              <ActiveItem
                className="active"
                active={activationPropsName || activationDefaultProps}
                primaryActionColor={primaryActionColor}
              >
                <i className="fas fa-check" />
              </ActiveItem>
            </ActiveIconContainer>
          )}
          <Input
            id={name}
            title={tooltip}
            isActive={activationPropsName || activationDefaultProps}
            name={name}
            data-testid={name}
            type={type}
            accept={accept}
            placeholder={placeholder}
            fontSize={inputFontSize}
            onClick={e => {
              e.stopPropagation()
            }}
            onChange={onChange}
            onInput={e => setInputValue(e.target.value)}
            onBlur={onBlur}
            value={transformedValue(type, inputValue)}
            disabled={disabled}
            style={{ ...inputStyle }}
            {...propsIfNumber}
            {...(role !== "" && { role: role })}
            isLoading={isLoading}
            className={isLoading ? "loaderButton" : ""}
            maxLength={maxLength}
            onWheel={isDisableScroll ? e => handleScroll(e) : () => {}}
          />
          {showIcon && (
            <SearchIconContainer
              style={searchIconContainerStyle}
              onClick={onClickIcon || (() => {})}
              enableClick={onClickIcon !== undefined}
            >
              {icon}
            </SearchIconContainer>
          )}
        </InputContainer>
      </Container>
      {unvalidValue && <ErrorMessage role="errorMessageInput">{errorMessage}</ErrorMessage>}
    </>
  )
}

GenericInput.propTypes = {
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  activationDefaultProps: PropTypes.bool,
  containerStyle: PropTypes.object,
  inputContainerStyle: PropTypes.object,
  inputStyle: PropTypes.object,
  showIcon: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
  title: PropTypes.string,
  unvalidValue: PropTypes.bool,
  inputFontSize: PropTypes.string,
  errorMessage: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  role: PropTypes.string,
  fontSizeTitle: PropTypes.string,
  className: PropTypes.string,
  typeAccept: PropTypes.string,
  colorTitle: PropTypes.string,
  heightTitle: PropTypes.string,
  searchIconContainerStyle: PropTypes.object,
  withMinWidth: PropTypes.bool,
  tooltip: PropTypes.string,
  isLoading: PropTypes.bool,
  isHiddenFleche: PropTypes.bool,
  isDisableScroll: PropTypes.bool,
  maxLength: PropTypes.number,
}

GenericInput.defaultProps = {
  onClick: () => {},
  onChange: () => {},
  onBlur: () => {},
  name: "",
  value: "",
  placeholder: "",
  containerStyle: {},
  inputContainerStyle: {},
  inputStyle: {},
  icon: <i className="fas fa-search" />,
  activationDefaultProps: true,
  showIcon: true,
  title: "",
  unvalidValue: false,
  inputFontSize: "",
  errorMessage: "",
  type: "text",
  min: 0,
  max: 100,
  disabled: false,
  role: "",
  fontSizeTitle: fontSize?.title,
  className: "",
  accept: "",
  colorTitle: "#858585",
  heightTitle: "40px",
  searchIconContainerStyle: {},
  withMinWidth: true,
  tooltip: "",
  isLoading: false,
  isHiddenFleche: false,
  isDisableScroll: false,
}

export default GenericInput
